import {EventBus} from "../../../../common/ts/events/EventBus";
import {ShowGoogleOneTapRequestedEvent} from "./events";
import tracking from "../../../../common/ts/core/tracking";
import {Device} from "../../../../common/ts/types/Device";
import {ShowRetentionPopupMobileRequestedEvent} from "../../components/retention/email/main/events";
import {PopulateFormEvent} from "../../../../common/ts/core/dom";
import {EMAIL_RETENTION_FORM_IDS} from "../../components/retention/email/main/constants";

let eventBus: EventBus;
let userDevice: string;

function onGoogleTapSignIn(googleUser: any, device: string) {
    const user = parseJwt(googleUser.credential);
    if (user.name && !localStorage.getItem('name')) {
        localStorage.setItem('name', user.name);
    }

    if (user.email && !localStorage.getItem('email')) {
        localStorage.setItem('email', user.email);

        EMAIL_RETENTION_FORM_IDS.forEach(formId => {
            eventBus.emit(new PopulateFormEvent({
                selector: `#${formId}`,
                data: [["email", localStorage.getItem("email")]],
            }));
        });
    }

    setCookie('_showGoogleOneTap', 'true', 365 * 24 * 60 * 60 * 1000);

    eventBus.emit(new tracking.TrackAnalyticsEvent({
        name: 'serp-GOT-signin'
    }))

    if (device === Device.MOBILE) {
        eventBus.emit(new ShowRetentionPopupMobileRequestedEvent());
    }
}

function parseJwt(token: string) {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));

    return JSON.parse(jsonPayload);
}

function setCookie(name: string, value: string, expirationTimeInMs: number) {
    let date = new Date();
    date.setTime(date.getTime() + expirationTimeInMs);
    const expires = "expires=" + date.toUTCString();
    document.cookie = name + "=" + value + "; " + expires + "; Path=/";
}

export function showGoogleOneTapRequestedHandler() {
    const scriptEle = document.createElement("script");
    scriptEle.setAttribute("src", "https://accounts.google.com/gsi/client");
    scriptEle.setAttribute("type", "text/javascript");
    scriptEle.addEventListener("load", () => {
        //@ts-ignore
        window.google.accounts.id.initialize({
            client_id: "252924090129-dpceen6430rvpfjbks68uckhva7nf0m7.apps.googleusercontent.com",
            callback: function (googleUser: any) {
                onGoogleTapSignIn(googleUser, userDevice)
            },
        });

        //@ts-ignore
        window.google.accounts.id.prompt((notification) => {
            if (notification.isDisplayed()) {
                eventBus.emit(new tracking.TrackAnalyticsEvent({
                    name: 'serp-GOT-impression'
                }));
            }

            if (notification.isSkippedMoment()) {
                setCookie('_showGoogleOneTap', 'true', 365 * 24 * 60 * 60 * 1000);
                if (userDevice === Device.MOBILE) {
                    eventBus.emit(new ShowRetentionPopupMobileRequestedEvent());
                }
            }
        });
    });

    document.body.appendChild(scriptEle);
}

function init(ev: EventBus = EventBus.getInstance(), device: string) {
    userDevice = device;
    eventBus = ev;
    eventBus.subscribe(ShowGoogleOneTapRequestedEvent.TYPE, showGoogleOneTapRequestedHandler);
}

export default {
    init,
};
